module.exports = __webpack_public_path__ + "files/d4d7d513589b448d5b0f2df4aca70ff8.png";